export const getAscending = state => state.toasterReducer.settings.ascending
export const getMaxToShow = state => state.toasterReducer.settings.maxOnScreen
export const getTimeoutBarVisibility = state => state.toasterReducer.settings.showTimeoutBar
export const getRequestCountVisibility = state => state.toasterReducer.settings.showRepeatCount



// WEBPACK FOOTER //
// ./src/features/Toaster/data/settings/selectors.js